<template>
  <div class="btn-container">
    <p v-if="error.template" class="error-message">{{error.template}}</p>
    <button type="button" @click="loginWithApple()" class='btn btn--apple'>
      <img src="../../assets/icon_apple.svg" alt="Apple Logo" />
    </button>
  </div>
</template>

<script>
import { authenticationWithApple } from '@/helpers/Auth';
import ENV from '@/config/environment';

export default {
  name: 'AuthWithApple',
  data: function() {
    return {
      error: {
        template: ''
      }
    };
  },
  methods: {
    init() {
      // Config apple authentication
      window.AppleID.auth.init({
        clientId: ENV.apple_clientId,
        scope: 'name email',
        redirectURI: ENV.apple_signin_redirect,
        usePopup: true
      });
    },
    loginWithApple: async function() {
      //need to update apple configuration with new callback
      //will still use Ember to handle the response
      // window.location = ENV.apple_signin_redirect + '?returnTo='+encodeURIComponent(ENV.apple_signin_returnTo);
      await authenticationWithApple();
    }
  },
  created() {
    this.init();
  }
}
</script>

<style lang="sass">
  .section__form {
    .btn--apple {
      background-color: $black;
      position: relative;
      font-size: 0;
      padding: 0;
      height: 46px;
    }
  }
</style>